import { DiscountedItem } from 'modules/campaigns/hooks/useDiscountedItems';

export const groupDiscountedItemsByCategory = (items: DiscountedItem[]) =>
  items.reduce<{ id: string; name: string; items: DiscountedItem[] }[]>((groups, item) => {
    // All discounted items should belong to a category, and if not they cannot be use in a campaign
    const itemCategory = item.category;
    if (!itemCategory) {
      return groups;
    }

    const group = groups.find(cat => cat.id === itemCategory.id);
    if (group) {
      group.items.push(item);
    } else {
      groups.push({
        id: itemCategory.id,
        name: itemCategory.name,
        items: [item],
      });
    }
    return groups;
  }, []);
